export * from './shortcuts-modal/shortcuts-modal.component';
